import ShButton from '@/components/Helpers/ShButton';

// @vue/component
export default {
  name: 'WidgetCode',

  components: {
    ShButton,
  },

  props: {
    widget: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      buttonText: 'Skopiuj kod',
      installationType: '',
    };
  },

  computed: {
    widgetCode() {
      return `<script type="text/javascript">
        (function(d) {
            var s,c,o=function(){ o._.push(arguments)};o._=[],q=new Date().getMilliseconds();
            s=d.getElementsByTagName('script')[0];c=d.createElement('script');
            c.type='text/javascript';c.charset='utf-8';c.async=true,
            c.src='//${process.env.VUE_APP_WIDGET_URL}/loader.js?q='+q;s.parentNode.insertBefore(c,s);
        })(document);
  
        var _callweb = _callweb || {
            key : '${this.widget.key}',
        };
      </script>`;
    },
    isCodeLoading() {
      return this.$store.getters['app/pendingStoreActions'].includes([
        'widgets/getOne',
      ]);
    },
  },


  beforeMount() {
    this.resetFields();
  },

  methods: {
    onCopy() {
      this.buttonText = 'Skopiowano!';
    },
    resetFields() {
      this.buttonText = 'Skopiuj kod';
    },
    handleInstallationTypeChange(type) {
      this.installationType = type;
      this.buttonText = 'Skopiuj kod';
    },
  },
};
